/* ============================================================
   AWERI GIFT BOX - customizer PROTOTYPE v3 (UI only; touches no cart).
   One page, several boxes: every [data-gb] section is one box (its block data serialised into data-gb-data);
   the optional [data-gbm] chooser strip above them gets one card per box (name, photo, summaries, "from Rs X"
   computed = base + the cheapest option per slot) and shows only the chosen box (?box=<key> in the URL).
   Per box: the tray (open slots with a price; settled included cards with flavour chips), the "What's inside"
   packing list and the receipt bar (base + your picks = total). THE RULES: total = base price + the chosen slot
   options; a flavour choice is Assorted or EXACTLY N flavours (the CTA waits while a pick is incomplete).
   The CTA only reveals the prototype note and logs the payload a future cart wiring would send.
   Loaded by layout/theme.liquid on the page.build-your-gift-box template only.
   ============================================================ */
(function () {
  'use strict';

  function money(n) { try { return 'Rs ' + Math.round(n).toLocaleString('en-IN'); } catch (e) { return 'Rs ' + Math.round(n); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function art(item, cls, size) {
    return item.image
      ? '<img class="' + cls + '" src="' + esc(item.image) + '" alt="" width="' + size + '" height="' + size + '" loading="lazy">'
      : '<span class="' + cls + ' gb-c' + (item.i % 9) + '" aria-hidden="true"></span>';
  }

  /* ---------- one box ---------- */
  function initBox(root) {
    var data;
    try { data = JSON.parse(root.getAttribute('data-gb-data') || ''); } catch (e) { console.warn('[aweri-gift-box] bad data', e); return null; }
    if (!data) return null;
    data.slots = data.slots || []; data.options = data.options || []; data.included = data.included || [];
    if (!data.slots.length && !data.included.length) return null; // nothing to show
    var hasSlots = data.slots.length > 0; // a box can be fully included - only flavours to pick, no priced slot

    // options grouped by their menu key; every item keeps a stable index (-> the swatch colour when it has no image)
    var menus = {};
    data.options.forEach(function (o, i) { o.i = i; (menus[o.menu] = menus[o.menu] || []).push(o); });
    data.included.forEach(function (inc, i) {
      inc.i = i;
      inc.flavours = (inc.flavours || []).map(function (f) { return String(f).trim(); }).filter(Boolean);
      inc.pick = inc.flavours.length ? Math.min(Math.max(parseInt(inc.pick, 10) || 0, 0), inc.flavours.length) : 0;
    });

    var q = function (sel) { return root.querySelector(sel); };
    var slotsEl = q('[data-gb-slots]'), incEl = q('[data-gb-included]'), insideEl = q('[data-gb-inside]'),
        totalEl = q('[data-gb-total]'), baseEl = q('[data-gb-base]'), picksEl = q('[data-gb-picks]'), sepEl = q('[data-gb-sep]'), waitEl = q('[data-gb-wait]'),
        bar = q('[data-gb-bar]'), cta = q('[data-gb-cta]'), note = q('[data-gb-note]'), sheet = q('[data-gb-sheet]'),
        overlay = q('[data-gb-overlay]'), sheetTitle = q('[data-gb-sheet-title]'), opts = q('[data-gb-opts]');
    if (!sheet || !opts) return null;

    // state: the chosen option index per slot; the ticked flavour indexes per included item ([] = Assorted)
    function defaultIndex(s) {
      var m = menus[s.menu] || [], d = 0;
      if (s.def) m.forEach(function (o, k) { if (o.name === s.def) d = k; });
      return d;
    }
    var state = { slots: data.slots.map(defaultIndex), flavours: data.included.map(function () { return []; }) };
    var picking = null; // slot index while the sheet is open
    var flashT = null;

    function optionFor(si) { var s = data.slots[si]; return (menus[s.menu] || [])[state.slots[si]] || null; }
    function picksTotal() { var t = 0; data.slots.forEach(function (_, si) { var o = optionFor(si); if (o) t += Number(o.price) || 0; }); return t; }
    function total() { return (Number(data.basePrice) || 0) + picksTotal(); }
    function fromPrice() { // the cheapest possible box: base + the lowest-priced option of every slot
      var t = Number(data.basePrice) || 0;
      data.slots.forEach(function (s) { var m = menus[s.menu] || []; if (m.length) t += Math.min.apply(null, m.map(function (o) { return Number(o.price) || 0; })); });
      return t;
    }
    // flavour rule: no pick = Assorted; 1..N-1 = incomplete (the CTA waits); N = complete
    function need(i) { var inc = data.included[i]; return inc.pick ? inc.pick - state.flavours[i].length : 0; }
    function incomplete(i) { return state.flavours[i].length > 0 && need(i) > 0; }
    function anyIncomplete() { return data.included.some(function (_, i) { return incomplete(i); }); }
    function flavourText(i) {
      var inc = data.included[i], sel = state.flavours[i];
      if (!inc.pick) return '';
      if (!sel.length) return 'Assorted';
      var names = sel.map(function (k) { return inc.flavours[k]; }).join(', ');
      if (incomplete(i)) return names + ' (' + sel.length + ' of ' + inc.pick + ' picked)';
      return names + (inc.pickNote ? ' (' + inc.pickNote + ')' : '');
    }

    function render(picksChanged) {
      if (slotsEl) slotsEl.innerHTML = data.slots.map(function (s, si) {
        var o = optionFor(si);
        if (!o) return '<div class="gb-slot gb-slot--empty">' + esc(s.label) + ': add Slot options with the menu key "' + esc(s.menu) + '" in the theme editor.</div>';
        return '<button type="button" class="gb-slot" data-gb-pick="' + si + '" aria-label="' + esc(s.label) + ': ' + esc(o.name) + ', ' + money(o.price) + '. Tap to change">'
          + art(o, 'gb-slot__art', 120)
          + '<span class="gb-slot__text"><span class="gb-slot__label">' + esc(s.label) + '</span><span class="gb-slot__name">' + esc(o.name) + '</span>'
          + '<span class="gb-slot__meta"><b class="gb-slot__price">' + money(o.price) + '</b>' + (o.qty ? ' &middot; ' + esc(o.qty) : '') + '</span><span class="gb-slot__change">Change</span></span></button>';
      }).join('');

      if (incEl) incEl.innerHTML = data.included.map(function (inc, i) {
        var chips = '', hint = '';
        if (inc.pick) {
          var sel = state.flavours[i], none = !sel.length, full = sel.length >= inc.pick;
          chips = '<div class="gb-chips" role="group" aria-label="' + esc(inc.name) + ' flavours">'
            + '<button type="button" class="gb-chip' + (none ? ' is-on' : '') + '" data-gb-chip="' + i + ':-1" aria-pressed="' + none + '">Assorted</button>'
            + inc.flavours.map(function (f, k) {
                var on = sel.indexOf(k) !== -1, off = full && !on;
                return '<button type="button" class="gb-chip' + (on ? ' is-on' : '') + '" data-gb-chip="' + i + ':' + k + '" aria-pressed="' + on + '"' + (off ? ' aria-disabled="true"' : '') + '>' + esc(f) + '</button>';
              }).join('') + '</div>';
          if (incomplete(i)) hint = '<span class="gb-inc__hint" data-gb-flav-hint>Pick ' + need(i) + ' more, or keep Assorted</span>';
          else if (full) hint = '<span class="gb-inc__hint is-ok" data-gb-flav-hint>' + inc.pick + ' of ' + inc.pick + ' picked' + (inc.pickNote ? ' &middot; ' + esc(inc.pickNote) : '') + '</span>';
          else hint = '<span class="gb-inc__hint is-ok" data-gb-flav-hint>Assorted, or pick exactly ' + inc.pick + '</span>';
        }
        return '<div class="gb-inc"><div class="gb-inc__row">' + art(inc, 'gb-inc__art', 56)
          + '<div class="gb-inc__text"><span class="gb-inc__name">' + esc(inc.name) + '</span>'
          + '<span class="gb-inc__meta">' + (inc.qty ? esc(inc.qty) + ' &middot; ' : '') + '<span class="gb-inc__tag">&#10003; Included</span></span>'
          + (inc.pick ? '<span class="gb-inc__flav">Flavours: ' + esc(flavourText(i)) + '</span>' : '')
          + hint + '</div></div>' + chips + '</div>';
      }).join('');

      if (insideEl) insideEl.innerHTML = data.slots.map(function (s, si) {
        var o = optionFor(si);
        return o ? '<li><b>' + esc(s.label) + ':</b> ' + esc(o.name) + (o.qty ? ' (' + esc(o.qty) + ')' : '') + '</li>' : '';
      }).join('') + data.included.map(function (inc, i) {
        return '<li><b>' + esc(inc.name) + '</b>' + (inc.qty ? ', ' + esc(inc.qty) : '') + (inc.pick ? ' - ' + esc(flavourText(i)) : '') + '</li>';
      }).join('');

      if (totalEl) totalEl.textContent = money(total());
      if (baseEl) baseEl.textContent = (data.baseLabel || 'Base') + ' ' + money(data.basePrice);
      if (picksEl && !hasSlots) { picksEl.hidden = true; if (sepEl) sepEl.hidden = true; } // fully included: the base is the price
      else if (picksEl) {
        picksEl.textContent = 'Your ' + data.slots.length + ' ' + (data.slotNoun || 'picks') + ' ' + money(picksTotal());
        if (picksChanged) { // the figure that moved flashes so "why did the price change" answers itself
          picksEl.classList.add('is-changed');
          clearTimeout(flashT);
          flashT = setTimeout(function () { picksEl.classList.remove('is-changed'); }, 900);
        }
      }
      // the CTA waits while any flavour pick is incomplete
      var waiting = anyIncomplete();
      if (cta) { cta.disabled = waiting; cta.setAttribute('aria-disabled', waiting ? 'true' : 'false'); }
      if (bar) bar.classList.toggle('is-waiting', waiting);
      if (waitEl) waitEl.textContent = waiting ? 'Finish the flavour pick above (or keep Assorted)' : '';
    }

    /* ---------- picker sheet ---------- */
    function openPicker(si, opener) {
      var s = data.slots[si], list = menus[s.menu] || [], current = state.slots[si];
      picking = si;
      if (sheetTitle) sheetTitle.textContent = 'Choose ' + s.label;
      opts.innerHTML = list.map(function (it, i) {
        var on = i === current;
        return '<button type="button" role="radio" aria-checked="' + on + '" class="gb-opt' + (on ? ' is-current' : '') + '" data-gb-opt="' + i + '">'
          + art(it, 'gb-opt__art', 44) + '<span class="gb-opt__text"><span class="gb-opt__name">' + esc(it.name) + '</span>' + (it.qty ? '<span class="gb-opt__qty">' + esc(it.qty) + '</span>' : '') + '</span>'
          + '<span class="gb-opt__price">' + money(it.price) + '</span></button>';
      }).join('');
      sheet.hidden = false;
      if (overlay) overlay.hidden = false;
      requestAnimationFrame(function () { sheet.classList.add('open'); });
      var first = opts.querySelector('.is-current') || opts.firstElementChild;
      if (window.AweriModal) {
        AweriModal.open('gift-box', { panel: sheet, overlay: overlay, opener: opener, initialFocus: first, onClose: hideSheet });
      } else if (first) { first.focus(); }
    }
    // Runs on every close path (X, overlay, ESC, pick). Returns focus to the (re-rendered) slot the shopper came from.
    function hideSheet() {
      sheet.classList.remove('open');
      sheet.hidden = true;
      if (overlay) overlay.hidden = true;
      var si = picking; picking = null;
      if (si === null) return;
      var back = root.querySelector('[data-gb-pick="' + si + '"]');
      if (back) back.focus();
    }
    function closePicker() {
      if (window.AweriModal && AweriModal.isOpen('gift-box')) AweriModal.close('gift-box'); else hideSheet();
    }

    /* ---------- events (delegated; the tray is re-rendered on every change) ---------- */
    root.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-gb-pick]');
      if (pick) { openPicker(parseInt(pick.getAttribute('data-gb-pick'), 10) || 0, pick); return; }
      var opt = e.target.closest('[data-gb-opt]');
      if (opt && picking !== null) {
        state.slots[picking] = parseInt(opt.getAttribute('data-gb-opt'), 10) || 0;
        render(true);
        closePicker();
        return;
      }
      var chip = e.target.closest('[data-gb-chip]');
      if (chip) {
        if (chip.getAttribute('aria-disabled') === 'true') return; // the pick is full; untick one first
        var p = chip.getAttribute('data-gb-chip').split(':'), i = parseInt(p[0], 10) || 0, k = parseInt(p[1], 10);
        if (k < 0) { state.flavours[i] = []; }
        else { var arr = state.flavours[i], at = arr.indexOf(k); if (at === -1) arr.push(k); else arr.splice(at, 1); arr.sort(function (a, b) { return a - b; }); }
        render(false);
        var again = root.querySelector('[data-gb-chip="' + i + ':' + k + '"]');
        if (again) again.focus();
        return;
      }
      if (e.target.closest('[data-gb-sheet-close]')) { closePicker(); return; }
      if (e.target.closest('[data-gb-cta]')) {
        if (anyIncomplete()) return;
        // PROTOTYPE: no cart. Surface the note + log the payload a future cart wiring would send.
        if (note) note.hidden = false;
        var payload = {
          box: { key: root.getAttribute('data-gb-key'), name: root.getAttribute('data-gb-name') },
          base: { label: data.baseLabel, price: data.basePrice },
          slots: data.slots.map(function (s, si) { var o = optionFor(si); return o ? { slot: s.label, name: o.name, qty: o.qty, price: o.price } : null; }),
          included: data.included.map(function (inc, i) { return { name: inc.name, qty: inc.qty, flavours: state.flavours[i].map(function (k) { return inc.flavours[k]; }), pickNote: inc.pickNote }; }), // flavours [] = Assorted
          total: total()
        };
        console.info('[aweri-gift-box] box payload (prototype, not sent)', payload);
      }
    });
    if (overlay) overlay.addEventListener('click', closePicker); // no-AweriModal fallback; AweriModal binds its own

    render(false);

    // ponytail: one runnable check per box - ?gbtest=1 recomputes the default total independently and logs PASS/FAIL.
    if (/[?&]gbtest=1/.test(location.search)) {
      var exp = Number(data.basePrice) || 0;
      data.slots.forEach(function (s) { var m = menus[s.menu] || [], o = m[defaultIndex(s)]; if (o) exp += Number(o.price) || 0; });
      var got = total();
      console.log('[aweri-gift-box selftest] ' + (root.getAttribute('data-gb-key') || '?') + ' ' + (got === exp ? 'PASS' : 'FAIL') + ' total=' + got + ' expected=' + exp);
    }

    var wrap = root.closest('.aweri-gift-box-section') || root; // the Shopify section wrapper carries the schema class
    return {
      key: root.getAttribute('data-gb-key') || '',
      name: root.getAttribute('data-gb-name') || '',
      image: root.getAttribute('data-gb-image') || '',
      included: root.getAttribute('data-gb-included') || '',
      choose: root.getAttribute('data-gb-choose') || '',
      from: fromPrice(),
      hasSlots: hasSlots,
      el: wrap,
      show: function (on) { wrap.classList.toggle('is-active', !!on); }
    };
  }

  /* ---------- the chooser strip (one card per box on the page) ---------- */
  function initMenu(menu, boxes) {
    if (!boxes.length) { menu.innerHTML = '<div class="gbm-empty">Add an "Aweri Gift Box" section below the chooser to see a box here.</div>'; return; }
    menu.innerHTML = boxes.map(function (b, i) {
      return '<button type="button" class="gbm-card" data-gbm-key="' + esc(b.key) + '" aria-pressed="false">'
        + (b.image ? '<img class="gbm-card__art" src="' + esc(b.image) + '" alt="" width="480" height="360" loading="lazy">' : '<span class="gbm-card__art" aria-hidden="true"></span>')
        + '<span class="gbm-card__top"><span class="gbm-card__name">' + esc(b.name) + '</span><span class="gbm-card__tick" aria-hidden="true">&#10003;</span></span>'
        + (b.included ? '<span class="gbm-card__line"><b>Included</b>' + esc(b.included) + '</span>' : '')
        + (b.choose ? '<span class="gbm-card__line"><b>You choose</b>' + esc(b.choose) + '</span>' : '')
        + '<span class="gbm-card__from">' + (b.hasSlots ? '<small>from</small> ' : '') + money(b.from) + '</span></button>';
    }).join('');

    function select(key, byTap) {
      var found = boxes.some(function (b) { return b.key === key; });
      if (!found) key = boxes[0].key;
      boxes.forEach(function (b) { b.show(b.key === key); });
      menu.querySelectorAll('[data-gbm-key]').forEach(function (c) {
        var on = c.getAttribute('data-gbm-key') === key;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      try {
        var url = new URL(location.href); url.searchParams.set('box', key); history.replaceState(null, '', url.toString());
      } catch (e) { /* URL API unavailable: the choice still shows, it just is not in the address bar */ }
      if (byTap) {
        var active = boxes.filter(function (b) { return b.key === key; })[0];
        if (active && active.el.getBoundingClientRect().top > window.innerHeight * 0.6) active.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // arriving on a shared ?box= link: bring the selected card into the strip's view (horizontal only; block:
        // 'nearest' leaves the page's vertical position alone when the strip is already on screen)
        var card = menu.querySelector('[data-gbm-key="' + key + '"]');
        if (card && card.scrollIntoView) card.scrollIntoView({ block: 'nearest', inline: 'start' });
      }
    }
    menu.addEventListener('click', function (e) {
      var card = e.target.closest('[data-gbm-key]');
      if (card) select(card.getAttribute('data-gbm-key'), true);
    });
    var initial = null;
    try { initial = new URLSearchParams(location.search).get('box'); } catch (e) { /* fall through to the first box */ }
    select(initial || boxes[0].key, false);
  }

  var boxes = [];
  document.querySelectorAll('[data-gb]').forEach(function (root) { var b = initBox(root); if (b) boxes.push(b); });
  var menu = document.querySelector('[data-gbm]');
  if (menu) initMenu(menu, boxes);
  else boxes.forEach(function (b) { b.show(true); }); // no chooser on the page: every box renders
})();
